import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthSessionService } from '../services/auth-session.service';

@Injectable({
  providedIn: 'root',
})
export class ProtectedGuard implements CanActivate {
  constructor(
    private session: AuthSessionService,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.session.ready().pipe(
      map((profile) => {
        if (!profile) {
          return this.router.createUrlTree(['/login']);
        }
        return true;
      }),
    );
  }
}
